import { Button } from 'common/Components/Button';
import { CircleInfoIcon } from 'common/Icons';
import { useRouter } from 'common/hooks/useRouter';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAccountActivationStep } from 'redux/common/AccountActivationSlice';

const Agreement = () => {
  //
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { navigate } = useRouter();

  const goToLoginPage = () => {
    dispatch(setAccountActivationStep('Agreement'));
    navigate.pushLogin();
  };

  return (
    <div className="flex flex-col gap-2 items-center">
      <div className="w-full flex text-L-gray-500 text-2xl text-justify px-4 font-medium flex-col gap-6 mt-4 h-[380px] overflow-y-auto">
        <p className="text-L-primary-50">
          {t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Header`)}
        </p>
        <p className="text-L-info-100 flex gap-1">
          <CircleInfoIcon />
          {t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Attention`)}
        </p>
        <p>{t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Term1`)}</p>
        <p>{t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Term2`)}</p>
        <p>{t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Term3`)}</p>
        <p>{t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Term4`)}</p>
        <p>{t(`BrokerCode_${window.api?.BROKER_CODE}.Agreement.Term5`)}</p>
      </div>
      <div className="w-full mt-2">
        <Button
          onClick={() => dispatch(setAccountActivationStep('SendingRequest'))}
          className="w-full bg-L-secondary-50 dark:bg-D-secondary-50 rounded text-L-basic dark:text-D-basic p-2 text-2xl mb-6"
        >
          {t(`FormSide.AcceptTerms`)}
        </Button>
        <p
          onClick={goToLoginPage}
          className="text-center cursor-pointer text-L-primary-50 text-xl md:text-b2xl lg:text-2xl mb-2"
        >
          {t('FormSide.BackText')}
        </p>
      </div>
    </div>
  );
};

export default Agreement;